import {ArrowRightOutlined} from '@ant-design/icons';
import {useEffect, useState} from 'react';
import {GiGymBag} from 'react-icons/gi';
import {Link} from 'react-router-dom';

import {RQGetAllHomeImagesAPI} from '../../../reactQuery/apis';

const MiddleImageSection = () => {
  const {data = []} = RQGetAllHomeImagesAPI();
  const [middleImage, setMiddleImage] = useState('');
  const [title, setTitle] = useState('Discover Your Perfect Bag');
  const [description, setDescription] = useState(
    `From backpacks and totes to stylish satchels and versatile travel bags — find the perfect bag for every occasion.  
Designed to move with you, our bags combine style, comfort, and durability for your everyday adventures.  
Whether you're heading to work, exploring the city, or traveling the world, our collection ensures you carry everything you need in style.  
Lightweight, functional, and effortlessly chic — your ideal bag is just a click away!`,
  );
  useEffect(() => {
    const middleSection = data
      .filter(item => item.isActive)
      .find(item => item.middleImage);

    if (!middleSection) {return;}

    setMiddleImage(middleSection.middleImage || '/placeholder.jpg');

    if (middleSection.middleTitle) {setTitle(middleSection.middleTitle);}
    if (middleSection.middleDescription)
    {setDescription(middleSection.middleDescription);}
  }, [data]);

  if (!middleImage) {return null;}

  return (
    <section data-aos={'fade-up'} className={'w-full px-4'}>
      <div className={'section mx-auto relative flex flex-col lg:flex-row items-center'}
      >
        {/* Mobile text section */}
        <div className={'section mx-auto relative flex flex-col lg:flex-row items-center'}>

          {/* TEXT SECTION */}
          <div
            className={'w-full max-w-72 bg-primary-950 text-primary-50 shadow-2xl rounded-md p-3 md:p-4  z-10 relative -mb-20 md:max-w-xl lg:absolute lg:left-0 lg:top-1/2 lg:-translate-y-1/2 lg:ml-6 lg:mb-0'}
          >
            <div className={'flex lg:p-6 p-3 flex-col gap-4 border rounded-md border-primary-200'}>
              <h2 className={'flex gap-2 items-center text-2xl lg:text-3xl font-extrabold text-white font-serif'}>
                <GiGymBag /> {title}
              </h2>

              <p className={'text-sm sm:text-base text-gray-300 leading-relaxed'}>
                {description}
              </p>

              <Link to={'/product'}>
                <button className={'mt-2 inline-flex items-center gap-2 bg-primary-800 text-white border-2 border-primary-600 px-6 py-2 rounded-lg text-xs font-semibold hover:opacity-90 transition'}>
          Shop Now <ArrowRightOutlined />
                </button>
              </Link>
            </div>
          </div>

          {/* IMAGE SECTION */}
          <div className={'w-full lg:w-3/5 ml-auto relative'}>
            <img
              src={middleImage}
              alt={title}
              className={' w-full rounded-md h-[420px] md:h-[430px] relative'}
            />
          </div>

        </div>
      </div>
    </section>

  );
};

export default MiddleImageSection;
